module.exports = __webpack_public_path__ + "static/media/sfl_3.ce9da671.jpg";